import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { ModalHeader, ModalBody, ModalFooter, Col, Row } from 'reactstrap';
import { ComboBox } from 'cd-eft/components/common/ComboBox';
import { Input } from 'cd-eft/components/common/Input';
import { liningMaterialOptions } from 'cd-eft/components/Design/Waterway/WDTContainer/WDTContentComp/WaterwayInput/WaterwayInputVM';
import { IWaterwayLiningMaterialUpdateProps, WaterwayLiningMaterialUpdateVM } from './WaterwayLiningMaterialUpdateVM';

export const WaterwayLiningMaterialUpdate: React.FC<IWaterwayLiningMaterialUpdateProps> = observer((props) => {
  const vm = useRef(new WaterwayLiningMaterialUpdateVM(props)).current;

  return (
    <div className="manual-entry-modal">
      <ModalHeader>
        <div className="modal-header-content">Lining Material</div>
      </ModalHeader>
      <ModalBody>
        <div className="modal-body-content">
          <Col>
            <Row>
              <ComboBox
                idAndName="liningMaterial"
                label=" Select Lining Material"
                aria-label="Select Lining Material"
                valid={true}
                value={vm.selectedOption}
                onChange={vm.handleLiningMaterialChange}
                onBlur={vm.validateInputField}
                options={liningMaterialOptions}
                errorMsg={''}
                required={true}
                className={vm.formErrors.comboxSelection}
              />
            </Row>
            {vm.manualEntryEnable && (
              <div className="manual_entry_section">
                <Row className="row-inline">
                  <Input
                    idAndName="manual_entry_material"
                    label="Manually enter new material name"
                    valid={vm.formErrors.manualEntryMaterial === ''}
                    value={vm.manualEntryName}
                    type="text"
                    onBlur={vm.validateInputField}
                    onChange={vm.handleManualEntryChange}
                    wrapperClassName="waterwayHorizontal"
                    className={vm.formErrors.manualEntryMaterial}
                  />
                  <Input
                    idAndName="manual_entry_manning"
                    label="Manually enter new Manning's n value"
                    valid={vm.formErrors.manualEntryManning === ''}
                    value={vm.manning.toString()}
                    type="number"
                    onBlur={vm.validateInputField}
                    onChange={vm.handleManualEntryChange}
                    wrapperClassName="waterwayHorizontal"
                    className={vm.formErrors.manualEntryManning}
                  />
                </Row>
                <Row className="full-width">
                  <Input
                    idAndName="manual_entry_thickness"
                    label="Manually enter new Lining Thickness (in)"
                    valid={vm.formErrors.manualEntryThickness === ''}
                    value={vm.thickness}
                    type="number"
                    onBlur={vm.validateInputField}
                    onChange={vm.handleManualEntryChange}
                    wrapperClassName="waterwayHorizontal"
                    className={vm.formErrors.manualEntryThickness}
                  />
                </Row>
              </div>
            )}
          </Col>
        </div>
      </ModalBody>
      <ModalFooter>
        <div>
          <button className="usa-button usa-button--outline close-button" onClick={vm.handleClose}>
            Close
          </button>
          <button className="usa-button save-button" disabled={vm.isFormInvalid()} onClick={vm.handleSave}>
            Apply to Selected Reaches
          </button>
        </div>
      </ModalFooter>
    </div>
  );
});
